import React, { Fragment } from "react";
import RightBar from "../components/account/RightBar";
import EventCenter from "../components/Event/EventCenter";
import Headbar from "../components/Layout/Headbar";
import { isEmpty } from "../common/cores";
import { isMobile } from "../utils/utils";
import MobileStickyFootbar from "../components/Layout/MobileStickyFootbar";

const E_Event = () => {
  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <div id="contentTheme"></div>
          <Headbar />
          <div
            className="title_wrap"
            style={{ paddingTop: isMobile() && "10px" }}
          >
            <div className="title_box">
              <div className="title">
                {isEmpty(window.lang["이벤트"])
                  ? "이벤트"
                  : window.lang["이벤트"]}
              </div>
            </div>
          </div>
          <div
            data-v-623d66c4=""
            className="mypage_cont event-contents"
            style={{ flexDirection: "row" }}
          >
            <EventCenter />
          </div>
        </div>
      </div>
      {isMobile() && <MobileStickyFootbar />}
    </Fragment>
  );
};

export default E_Event;



// WEBPACK FOOTER //
// ./src/containers/E_Event.js